import { createApp } from "vue"
import { createRouter, createWebHashHistory } from "vue-router"


// 按需加载，访问路径的时候才会加载，不访问，不加载   =======
const Home = () => import("@/views/home/Home.vue") // 引入组件 打包会打包在文件中，如果都用import的话，所有组件都会打包在一个文件中，导致文件很大
const username = () => import("@/views/home/username.vue")
const bill = () => import("@/views/home/bill.vue")
const notice = () => import("@/views/notice/notice.vue")
const messageSubscription = () => import("@/views/notice/messageSubscription.vue")


// const officialMaterial = () => import("@/views/Material/officialMaterial.vue")
const myMaterial = () => import("@/views/Material/myMaterial.vue")
const customFont = () => import("@/views/Material/customFont.vue")
// const myCustomMaterial = () => import("@/views/Material/myCustomMaterial.vue")
// const shareMaterial = () => import("@/views/Material/shareMaterial.vue")
// const officialTheme = () => import("@/views/Material/officialTheme.vue")
// const myTheme = () => import("@/views/Material/myTheme.vue")

// const myProduct = () => import("@/views/chooseProducts/myProduct.vue")
// const customsClearance = () => import("@/views/chooseProducts/customsClearance.vue")
// const costCalculation = () => import("@/views/chooseProducts/costCalculation.vue")
// const childAccount = () => import("@/views/chooseProducts/childAccount.vue")


const officialFinished = () => import("@/views/finishedProduct/officialFinished.vue")
const myFinished = () => import("@/views/finishedProduct/myFinished.vue")
const replacement = () => import("@/views/finishedProduct/replacement.vue")
const myFinished2 = () => import("@/views/finishedProduct/myFinished2.vue")
const designRecords = () => import("@/views/finishedProduct/designRecords.vue")




const storeManagement = () => import("@/views/Published/storeManagement.vue")
const productTemplate = () => import("@/views/Published/productTemplate.vue")
const pricingTemplate = () => import("@/views/Published/pricingTemplate.vue")
const pricingManagement = () => import("@/views/Published/pricingManagement.vue")
const asinProduct = () => import("@/views/Published/asinProduct.vue")
const EANUPC = () => import("@/views/Published/EANUPC.vue")
const Infringement = () => import("@/views/Published/Infringement.vue")
const bannedWord = () => import("@/views/Published/bannedWord.vue")
// const Watermark = () => import("@/views/Published/Watermark.vue" )
// const Image = () => import("@/views/Published/Image.vue" )
const Keyword = () => import("@/views/Published/KeyWord.vue")
const propertyManagement = () => import("@/views/Published/propertyManagement.vue")
const productTitleTemplate = () => import("@/views/Published/productTitleTemplate.vue")
const SKU = () => import("@/views/Published/SKU.vue")
// const outRecord = () => import("@/views/Published/outRecord.vue")
// const publishedProducts = () => import("@/views/Published/publishedProducts.vue")
// const Designer = () => import("@/views/Published/designer.vue")

const quickOrder = () => import("@/views/Order/quickOrder.vue")
const Cart = () => import("@/views/Order/cart.vue")
const orderManagement = () => import("@/views/Order/orderManagement.vue")
const orderShopManagement = () => import("@/views/Order/orderShopManagement.vue")
// const productLinkRecord = () => import("@/views/Order/productLinkRecord.vue")
// const materialOrder = () => import("@/views/Order/materialOrder.vue")
// const fbaDelivery = () => import("@/views/Order/fbaDelivery.vue")
// const fbaFill = () => import("@/views/Order/fbaFill.vue")
// const sendPayList = () => import("@/views/Order/sendPayList.vue" )
// const customerList = () => import("@/views/Order/customerList.vue")
// const profitManagement = () => import("@/views/Order/profitManagement.vue")
// const disabledList = () => import("@/views/Order/disabledList.vue")

// const tradingSummary = () => import("@/views/Summary/tradingSummary.vue") 
// const tradingDetails = () => import("@/views/Summary/tradingDetails.vue")
// const resourcesRanking = () => import("@/views/Summary/resourcesRanking.vue")
// const exportRecord = () => import("@/views/Summary/exportRecord.vue")

// const Model = () => import("@/model/index.vue")
// const ModelChange = () => import("@/model/setChange.vue")
// const ModelPinban = () => import("@/model/pinban.vue")

const Setting = () => import("@/views/system/setting.vue")
const LoginRecords = () => import("@/views/system/loginRecords.vue")
const Certification = () => import("@/views/system/certification.vue")
const Batchdesign = () => import("@/views/chooseProducts/batchDesign.vue")
const BatchRecord = () => import("@/views/chooseProducts/batchRecord.vue")
const Statistic = () => import("@/views/Statistic/index.vue")

// 按需加载，访问路径的时候才会加载，不访问，不加载  

const Login = () => import("@/views/User/login.vue")
const Settlement = () => import("@/views/Order/settlement.vue")


const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        {
            path: "/",
            name: "home",
            title: "首页",
            component: Home
        },
        // {
        //     path: "/mt",
        //     name: "mt",
        //     title: "模特",
        //     component: Model,
        // },
        // {
        //     path: "/modelchange",
        //     name: "modelchange",
        //     title: "模特设置",
        //     component: ModelChange,
        // },
        // {
        //     path: "/pinban",
        //     name: "pinban",
        //     title: "模特设置",
        //     component: ModelPinban
        // },
        {
            path: "/login",
            name: "login",
            title: "登录",
            component: Login,
            meta: {
                isHeader: true
            }
        },
        {
            path: "/username",
            name: "username",
            title: "用户名",
            component: username
        },
        {
            path: "/setting",
            name: "setting",
            title: "设置",
            component: Setting
        },
        {
            path: "/loginRecords",
            name: "loginRecords",
            title: "登录记录",
            component: LoginRecords
        },
        {
            path: "/certification",
            name: "certification",
            title: "实名认证",
            component: Certification
        },
        {
            path: "/bill",
            name: "bill",
            title: "我的账单",
            component: bill
        },
        {
            path: "/statistic",
            name: "statistic",
            title: "统计分析",
            component: Statistic
        },
        // {
        //     path: "/officialMaterial",
        //     name: "officialMaterial",
        //     title: "官方素材",
        //     component: officialMaterial
        // },
        {
            path: "/myMaterial",
            name: "myMaterial",
            title: "我的素材",
            component: myMaterial
        },
        {
            path: "/customFont",
            name: "customFont",
            title: "自定义字体",
            component: customFont
        },
        // {
        //     path: "/myCustomMaterial",
        //     name: "myCustomMaterial",
        //     title: "我的定制素材",
        //     component: myCustomMaterial
        // },
        // {
        //     path: "/shareMaterial",
        //     name: "shareMaterial",
        //     title: "共享素材库",
        //     component: shareMaterial
        // },
        // {
        //     path: "/officialTheme",
        //     name: "officialTheme",
        //     title: "官方主题",
        //     component: officialTheme
        // },
        // {
        //     path: "/myTheme",
        //     name: "myTheme",
        //     title: "官方主题",
        //     component: myTheme
        // },
        // {
        //     path: "/myProduct",
        //     name: "myProduct",
        //     title: "我的产品库",
        //     component: myProduct
        // },
        // {
        //     path: "/customsClearance",
        //     name: "customsClearance",
        //     title: "自定义报关信息",
        //     component: customsClearance
        // },
        // {
        //     path: "/costCalculation",
        //     name: "costCalculation",
        //     title: "自定义报关信息",
        //     component: costCalculation
        // },
        // {
        //     path: "/childAccount",
        //     name: "childAccount",
        //     title: "产品库子账号权限",
        //     component: childAccount
        // },
        {
            path: "/officialFinished",
            name: "officialFinished",
            title: "官方成品",
            component: officialFinished
        },
        {
            path: "/replacement",
            name: "replacement",
            title: "替换",
            component: replacement
        },
        {
            path: "/myFinished",
            name: "myFinished",
            title: "我的成品",
            component: myFinished
        },
        {
            path: "/myFinished2",
            name: "myFinished2",
            title: "我的成品",
            component: myFinished2
        },
        {
            path: "/designRecords",
            name: "designRecords",
            title: "设计记录",
            component: designRecords
        },
        {
            path: "/storeManagement",
            name: "storeManagement",
            title: "店铺管理",
            component: storeManagement
        },
        {
            path: "/asinProduct",
            name: "asinProduct",
            title: "刊登产品",
            component: asinProduct
        },
        {
            path: "/productTemplate",
            name: "productTemplate",
            title: "产品模板",
            component: productTemplate
        },
        {
            path: "/pricingTemplate",
            name: "pricingTemplate",
            title: "定价模板",
            component: pricingTemplate
        },
        {
            path: "/pricingManagement",
            name: "pricingManagement",
            title: "定价模板管理",
            component: pricingManagement
        },
        {
            path: "/EANUPC",
            name: "EANUPC",
            title: "EAN/UPC管理",
            component: EANUPC
        },
        {
            path: "/Infringement",
            name: "Infringement",
            title: "侵权资源处理",
            component: Infringement
        },
        {
            path: "/bannedWord",
            name: "bannedWord",
            title: "自定义违禁词",
            component: bannedWord
        },
        // {
        //     path: "/Watermark",
        //     name: "Watermark",
        //     title: "水印设置",
        //     component:Watermark
        // },
        // {
        //     path: "/Image",
        //     name: "Image",
        //     title: "图片独立域名 ",
        //     component:Image
        // },
        {
            path: "/Keyword",
            name: "Keyword",
            title: "自定义关键字 ",
            component: Keyword
        },
        {
            path: "/propertyManagement",
            name: "propertyManagement",
            title: "属性管理",
            component: propertyManagement
        },
        {
            path: "/productTitleTemplate",
            name: "productTitleTemplate",
            title: "产品标题模版",
            component: productTitleTemplate
        },
        {
            path: "/SKU",
            name: "SKU",
            title: "属性管理",
            component: SKU
        },
        {
            path: "/Batchdesign",
            name: "Batchdesign",
            title: "批量设计",
            component: Batchdesign
        },
        {
            path: "/batchRecord",
            name: "batchRecord",
            title: "设计记录",
            component: BatchRecord
        },
        // {
        //     path: "/outRecord",
        //     name: "outRecord",
        //     title: "汇出记录",
        //     component:outRecord
        // },
        // {
        //     path: "/publishedProducts",
        //     name: "publishedProducts",
        //     title: "刊登产品",
        //     component:publishedProducts
        // },
        // {
        //     path: "/Designer",
        //     name: "Designer",
        //     title: "设计器管理",
        //     component:Designer
        // },
        {
            path: "/quickOrder",
            name: "quickOrder",
            title: "快速下单",
            component: quickOrder
        },
        {
            path: "/Cart",
            name: "Cart",
            title: "购物车",
            component: Cart
        },
        {
            path: "/settlement",
            name: "settlement",
            title: "结算",
            component: Settlement
        },
        {
            path: "/orderManagement",
            name: "orderManagement",
            title: "订单管理",
            component: orderManagement
        },
        {
            path: "/orderShopManagement",
            name: "orderShopManagement",
            title: "店铺管理",
            component: orderShopManagement
        },
        {
            path: "/notice",
            name: "notice",
            title: "消息中心",
            component: notice
        },
        {
            path: "/messageSubscription",
            name: "messageSubscription",
            title: "消息订阅管理",
            component: messageSubscription
        },
        // {
        //     path: "/productLinkRecord",
        //     name: "productLinkRecord",
        //     title: "产品关联记录",
        //     component:productLinkRecord
        // },
        // {
        //     path: "/materialOrder",
        //     name: "materialOrder",
        //     title: "素材订单",
        //     component:materialOrder
        // },
        // {
        //     path: "/fbaDelivery",
        //     name: "fbaDelivery",
        //     title: "FBA发货计划",
        //     component:fbaDelivery
        // },
        // {
        //     path: "/fbaFill",
        //     name: "fbaFill",
        //     title: "FBA线上补货",
        //     component:fbaFill
        // },
        // {
        //     path: "/sendPayList",
        //     name: "sendPayList",
        //     title: "寄付清单",
        //     component:sendPayList
        // },
        // {
        //     path: "/customerList",
        //     name: "customerList",
        //     title: "售后列表",
        //     component:customerList
        // },
        // {
        //     path: "/profitManagement",
        //     name: "profitManagement",
        //     title: "利润管理",
        //     component:profitManagement
        // },
        // {
        //     path: "/disabledList",
        //     name: "disabledList",
        //     title: "黑名单",
        //     component:disabledList
        // },
        // {
        //     path: "/tradingSummary",
        //     name: "tradingSummary",
        //     title: "交易汇总",
        //     component:tradingSummary
        // },
        // {
        //     path: "/tradingDetails",
        //     name: "tradingDetails",
        //     title: "交易明细",
        //     component:tradingDetails
        // },
        // {
        //     path: "/resourcesRanking",
        //     name: "resourcesRanking",
        //     title: "资源排行",
        //     component:resourcesRanking
        // },
        // {
        //     path: "/exportRecord",
        //     name: "exportRecord",
        //     title: "资源排行",
        //     component:exportRecord
        // }
    ]
})
const isGo = false;
router.beforeEach(async (to, from, next) => {

    console.log(to, from);
    const queryTokenArr = to.query.token;
    const queryToken = Array.isArray(queryTokenArr) ? queryTokenArr[0] : queryTokenArr || '';
    const storageToken = localStorage.getItem("token");
    const token = queryToken ? queryToken : storageToken;
    console.log(queryToken, storageToken, token);
    if (queryToken) {
        localStorage.setItem("token", queryToken);
    }
    next();
    return;
})
router.beforeResolve(async (to, from, next) => {
    next();
})

createApp({}).use(router)

export default router;
